<template>
  <Teleport to="body">
    <Transition name="modal">
      <div v-if="show" class="modal-overlay" @click.self="close">
        <div class="modal-container">
          <div class="modal-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
              <polyline points="10 17 15 12 10 7"></polyline>
              <line x1="15" y1="12" x2="3" y2="12"></line>
            </svg>
          </div>

          <h2 class="modal-title">需要登录</h2>

          <p class="modal-message">
            请先登录以使用 SnapClip。登录后您的数据将被安全保存，并且在不同设备间同步。
          </p>

          <div class="modal-actions">
            <button class="btn btn-primary" @click="goToLogin">
              立即登录
            </button>
            <button class="btn btn-secondary" @click="close">
              稍后再说
            </button>
          </div>

          <p class="modal-note">
            提示：登录后每个用户的数据都是独立的，您的隐私将得到保护。
          </p>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useUserStore } from '../stores/user';
import { storeToRefs } from 'pinia';

const userStore = useUserStore();
const { showLoginPrompt } = storeToRefs(userStore);

const show = showLoginPrompt;

function close() {
  userStore.closeLoginPrompt();
}

function goToLogin() {
  userStore.goToLogin();
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.modal-container {
  background: var(--bg-card, #ffffff);
  border-radius: 16px;
  padding: 32px;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.modal-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  color: var(--color-primary, #4f46e5);
}

.modal-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 12px;
  color: var(--color-text, #1a1a1a);
}

.modal-message {
  font-size: 15px;
  line-height: 1.6;
  color: var(--color-text-secondary, #666);
  margin-bottom: 24px;
}

.modal-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.btn {
  flex: 1;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.btn-primary {
  background: var(--color-primary, #4f46e5);
  color: white;
}

.btn-primary:hover {
  background: var(--color-primary-dark, #4338ca);
  transform: translateY(-1px);
}

.btn-secondary {
  background: var(--bg-secondary, #f5f5f5);
  color: var(--color-text, #1a1a1a);
}

.btn-secondary:hover {
  background: var(--bg-tertiary, #e5e5e5);
}

.modal-note {
  font-size: 13px;
  color: var(--color-text-tertiary, #999);
  line-height: 1.5;
}

/* Modal transition */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-active .modal-container,
.modal-leave-active .modal-container {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(0.9) translateY(-20px);
  opacity: 0;
}

/* Dark mode */
@media (prefers-color-scheme: dark) {
  .modal-container {
    --bg-card: #2a2a2a;
    --color-text: #ffffff;
    --color-text-secondary: #a0a0a0;
    --color-text-tertiary: #666;
    --bg-secondary: #3a3a3a;
    --bg-tertiary: #4a4a4a;
  }
}
</style>
